import api from '@/lib/axios';
import type { Booking, CreateBookingDTO, UpdateBookingDTO, ApiResponse, LaravelPaginator } from '@/types';

/**
 * Serviço de reservas.
 * Rotas: /v1/reservas/*
 */
export const bookingsService = {
  /**
   * Listar todas as reservas
   * GET /v1/reservas
   */

  async list(params?: { page?: number; per_page?: number; status?: string; search?: string }): Promise<LaravelPaginator<Booking>> {
    const { data } = await api.get<ApiResponse<{ bookings: LaravelPaginator<Booking> }>>('/v1/reservas', { params });
    // Retorna o paginator diretamente para facilitar o uso no front
    return data.data.bookings;
  },

  /**
   * Obter reserva por ID
   * GET /v1/reservas/:id
   */
  async get(id: number): Promise<Booking> {
    const { data } = await api.get<ApiResponse<{ booking: Booking }>>(`/v1/reservas/${id}`);
    return data.data.booking;
  },

  /**
   * Criar nova reserva
   * POST /v1/reservas
   */
  async create(payload: CreateBookingDTO): Promise<Booking> {
    const { data } = await api.post<ApiResponse<{ booking: Booking }>>('/v1/reservas', payload);
    return data.data.booking;
  },

  /**
   * Atualizar reserva
   * PUT /v1/reservas/:id
   */
  async update(id: number, payload: UpdateBookingDTO): Promise<Booking> {
    const { data } = await api.put<ApiResponse<{ booking: Booking }>>(`/v1/reservas/${id}`, payload);
    return data.data.booking;
  },

  /**
   * Deletar reserva
   * DELETE /v1/reservas/:id
   */
  async delete(id: number): Promise<void> {
    await api.delete(`/v1/reservas/${id}`);
  },
};
